import React from 'react';

import { connect } from "react-redux"//联系store的组件
import evn from "./../../../../../actions/index"//action的所有事件

import "./style.css"//引入样式
import { Radio, Modal, Form, Input, message, Icon, Tooltip } from 'antd';//引入antd组件
import { Hcurl } from "./../../../../../constants/index"//获取公共路径
import Event from "./../../../../../assets/PubJs/hcPub"//所有事件
import EventSet from "./../../../../../assets/PubJs/hcPub"//所有事件
import $ from "jquery"
import createHistory from 'history/createHashHistory';//路由切换地址
import { setTimeout } from 'core-js/library/web/timers';
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const FormItem = Form.Item;
const history = createHistory();//定义history路由

//加入企业组件
let _InvitationForm = null;
class InvitationForm extends React.Component {
    getCom_Name = () => {  //获取先行和解默认企业信息
        console.log(333)
        $.ajax({
            url: Hcurl + "/CompanyCore/GetXXHJCompanyDefultName?u_code=" + EventSet.getUserInfo().CU_Code,
            type: 'post',
            success: function (data) {
                console.log(data, 'success');
                let userInfo = JSON.parse(localStorage.userInfo);
                userInfo.xxhjcompanycode = data.split("|")[1];
                userInfo.XXHJCom_Name = data.split("|")[2];
                localStorage.setItem("userInfo", JSON.stringify(userInfo));

            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                console.log(data, 'error')
            }

        })
    }
    //加入企业表单提交
    handleSubmit = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let setData = {
                    UserCode: Event.getUserInfo().CU_Code,
                    InviteCode: values.yqm,
                    Type: _App.state.radioType,
                };
                $.ajax({
                    url: Hcurl + "/CompanyCore/AddCompany",
                    type: "post",
                    data: setData,
                    async: false,
                    headers: {
                        "token": EventSet.getUserInfo()['token']
                    },
                    success: function (res) {
                        //console.log(res, 'res');
                        if (res.split("|")[0] == "false") {
                            message.error(res.split("|")[1]);
                            _App.setState({
                                confirmLoading: false,
                            });
                        } else {
                            message.success("提交成功");
                            _InvitationForm.getCom_Name();
                            let userInfo = JSON.parse(localStorage.userInfo);
                            userInfo.UCR_ComID = res.split("|")[1];
                            userInfo.Com_Name = res.split("|")[2];
                            userInfo.UCR_IsAdmin = res.split("|")[3];
                            localStorage.setItem("userInfo", JSON.stringify(userInfo));
                            history.push({
                                pathname: "/Content/Business/CompanyList/test",
                            })
                            _App.props.dispatch(evn.closeModal())
                            _App.setState({
                                confirmLoading: false,
                            });
                            setTimeout(() => {
                                window.location.reload()
                            }, 300);
                            _InvitationForm.props.form.resetFields();
                        }
                    },
                    error: function (data, err) {
                        if (!JSON.parse(data.responseText).success && data.status === 403) {
                            history.push({ "pathname": "/err" })
                        } else {
                            message.error(err)
                        }
                    }
                })
            } else {
                _App.setState({
                    confirmLoading: false,
                });
            }
        });
    };

    //组件完成
    componentDidMount() {
        _InvitationForm = this
    }

    //组件渲染
    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div className={"CompanyModal_BindFrom"}>
                <div style={{ padding: "32px 24px 0" }}>
                    <Form onSubmit={this.handleSubmit} className="login-form">
                        <FormItem
                            label="邀请码"
                        >
                            {getFieldDecorator('yqm', {
                                rules: [{ required: true, message: '请输入有效的邀请码' }],
                            })(
                                <Input maxLength={8} placeholder="请输入邀请码号" />
                                )}
                        </FormItem>
                    </Form>
                </div>
            </div>
        );
    }
}
const WrappedInvitationForm = Form.create()(InvitationForm);

//绑定企业组件
let _NormalLoginForm = null;
class NormalLoginForm extends React.Component {

    state = {
        code: "none",
        text: ""
    }
    getCom_Name = () => {  //获取先行和解默认企业信息
        console.log(22222)
        $.ajax({
            url: Hcurl + "/CompanyCore/GetXXHJCompanyDefultName?u_code=" + EventSet.getUserInfo().CU_Code,
            type: 'post',
            success: function (data) {
                console.log(data, 'success');
                let userInfo = JSON.parse(localStorage.userInfo);
                userInfo.xxhjcompanycode = data.split("|")[1];
                userInfo.XXHJCom_Name = data.split("|")[2];
                localStorage.setItem("userInfo", JSON.stringify(userInfo));

            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                console.log(data, 'error')
            }

        })
    }
    //绑定企业组件表单提交
    handleSubmit = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let setData = {
                    UserCode: Event.getUserInfo().CU_Code,
                    CreditCode: values.xydm,
                    CompanyName: values.qymc,
                    Header: values.fddbrxm,
                    //LawCardNo: values.fddbrzjh,
                    Type: _App.state.radioType,
                };
                $.ajax({
                    url: Hcurl + "/CompanyCore/AddCompany",
                    type: "post",
                    data: setData,
                    async: false,
                    headers: {
                        "token": EventSet.getUserInfo()['token']
                    },
                    success: function (res) {
                        if (res.split("|")[0] == "false") {
                            message.error(res.split("|")[1]);
                            _App.setState({
                                confirmLoading: false,
                            });
                        } else {
                            message.success("提交成功")
                            let userInfo = JSON.parse(localStorage.userInfo);
                            userInfo.UCR_ComID = res.split("|")[1];
                            userInfo.Com_Name = res.split("|")[2];
                            userInfo.UCR_IsAdmin = res.split("|")[3];
                            localStorage.setItem("userInfo", JSON.stringify(userInfo))
                            let companyInfo = {};
                            companyInfo.Com_Code = res.split("|")[1];
                            companyInfo.Com_Name = res.split("|")[2];
                            companyInfo.UCR_IsAdmin = res.split("|")[3];
                            localStorage.setItem("companyInfo", JSON.stringify(companyInfo))
                            _NormalLoginForm.getCom_Name();
                            _App.setState({
                                confirmLoading: false,
                            });
                            _App.props.dispatch(evn.closeModal())
                            Modal.success({
                                title: '绑定成功',
                                content: '请完善您所绑定的企业信息',
                                okText: "确定",
                                onOk() {
                                    localStorage.setItem('tabValue','2')
                                    history.push({
                                        pathname: "/Content/Business/CompanyList/MainCenter",
                                    })
                                    // setTimeout(() => {
                                    //     window.location.reload()
                                    // }, 300);
                                    // _App.props.dispatch(evn.changeTagKey("2"))
                                },
                            });
                        }
                    },
                    error: function (data, err) {
                        if (!JSON.parse(data.responseText).success && data.status === 403) {
                            history.push({ "pathname": "/err" })
                        } else {
                            message.error(err)
                        }
                    }
                })
            } else {
                _App.setState({
                    confirmLoading: false,
                });
            }
        });
    };

    shenshu() {
        let url = window.location.href.split("#")[0] + "#/New/Statement"
        window.open(url)
    }

    codeTest() {
        let setData = {
            CreditCode: this.props.form.getFieldValue('xydm')
        };
        console.log(setData)
        $.ajax({
            url: Hcurl + "/CompanyCore/GetCreditCodeByBindInfo",
            type: "post",
            data: setData,
            async: false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (res) {
                if (res !== "" || res == null) {
                    _App.setState({
                        code: "block",
                        text: res.split("|")[1]
                    })
                }
            }
        })

    }
    codeChange() {
        _App.setState({
            code: "none",
            text: ""
        })
    }
    //组件完成
    componentDidMount() {
        _NormalLoginForm = this
    }

    //组件渲染
    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div className={"CompanyModal_BindFrom"}>
                <div style={{ padding: "32px 24px 0" }}>
                    <Form onSubmit={this.handleSubmit} className="login-form">
                        <FormItem
                            label="信用代码"
                        >
                            {getFieldDecorator('xydm', {
                                rules: [{ required: true, message: '请输入统一社会信用代码/注册号' }],
                            })(
                                <Input  placeholder="请输入统一社会信用代码/注册号" onBlur={this.codeTest.bind(this)} onChange={this.codeChange.bind(this)} />
                                )}
                            <Tooltip title={_App.state.text}>
                                <Icon type="close-circle" style={{ position: "absolute", right: "-24px", top: "3px", color: "red", display: _App.state.code }} />
                            </Tooltip>

                        </FormItem>

                        <FormItem
                            label="企业名称"
                        >
                            {getFieldDecorator('qymc', {
                                rules: [{ required: true, message: '请输入企业全称' }],
                            })(
                                <Input  placeholder="请输入企业全称" />
                                )}
                        </FormItem>
                        <FormItem
                            label="法定代表人姓名"
                        >
                            {getFieldDecorator('fddbrxm', {
                                rules: [{ required: true, message: '请输入法定代表人（负责人）姓名' }],
                            })(
                                <Input placeholder="请输入法定代表人（负责人）姓名" />
                                )}
                        </FormItem>
                        {/*
                         *  <FormItem
                            label="法定代表人证件号"
                        >
                            {getFieldDecorator('fddbrzjh', {
                                rules: [
                                    {required: true, message: '请输入法定代表人证件号码'},
                                    {pattern: /^[A-Za-z0-9]{15,18}$/, message: '请输入有效的证件号'},
                                ],
                            })(
                                <Input placeholder="请输入法定代表人证件号码，15-18位"/>
                            )}
                        </FormItem>
                         */}
                    </Form>
                    <p>注1：如您所绑定的企业最近发生过关于“企业全称”及“法定代表人姓名”的变更，在使用新信息绑定不成功时，请尝试使用企业变更前的信息进行绑定!</p>
                    <p>注2：企业已被其他人绑定，<a onClick={this.shenshu}>点击申诉</a></p>
                </div>
            </div>

        );
    }
}
const WrappedNormalLoginForm = Form.create()(NormalLoginForm);



let _App = null;
class App extends React.Component {

    state = {
        radioType: "1",
        confirmLoading: false,
        code: "none",
        text: ""
    };

    //点击确定事件
    handleOk = (e) => {
        this.setState({
            confirmLoading: true,
        });
        switch (this.state.radioType) {
            case ("1"): _NormalLoginForm.handleSubmit(); break;
            case ("2"): _InvitationForm.handleSubmit(); break
            default: console.log(this.state.radioType, "aaaa")
        }
    };

    componentWillReceiveProps(e) {
        _App.setState({
            confirmLoading: false,
            code: "none",
            text: ""
        });

        if (e.visible === false) {
            //重置表单
            switch (this.state.radioType) {
                case ("1"): _NormalLoginForm.props.form.resetFields(); break;
                case ("2"): _InvitationForm.props.form.resetFields(); break
                default: console.log(this.state.radioType, "aaaa")
            }
        }
    }

    //点击取消事件
    handleCancel = (e) => {
        this.props.dispatch(evn.closeModal())
    };

    //改变单选按钮
    onChange(e) {
        this.setState({
            radioType: e.target.value
        })
        if (e.target.value === "0") {
            let setData = {
                UserCode: Event.getUserInfo().CU_Code,
            };

            $.ajax({
                url: Hcurl + "/CompanyCore/GetSelectCompany",
                type: "post",
                data: setData,
                async: false,
                headers: {
                    "token": EventSet.getUserInfo()['token']
                },
                success: function (res) {
                    setTimeout(function () {
                        _BindCompany.setState({
                            list: JSON.parse(res)
                        })
                    }, 10)
                },
                error: function (data, err) {
                    if (!JSON.parse(data.responseText).success && data.status === 403) {
                        history.push({ "pathname": "/err" })
                    } else {
                        message.error(err)
                    }
                }
            })
        }
    }

    //组件完成
    componentDidMount() {
        _App = this
    }
    //渲染组件
    render() {
        return (
            <div id="CompanyModal">
                <Modal
                    title={this.props.type === "1" ? "绑定/加入企业" : "绑定/加入企业"}
                    visible={this.props.visible}
                    onOk={this.handleOk}
                    okText={"确定"}
                    cancelText={"取消"}
                    onCancel={this.handleCancel}
                    confirmLoading={this.state.confirmLoading}
                >
                    <div className={"CompanyModal_radioGroup"}>
                        <RadioGroup onChange={this.onChange.bind(this)} value={this.state.radioType}>
                            <RadioButton value="1">绑定企业</RadioButton>
                            <RadioButton value="2">加入企业</RadioButton>
                        </RadioGroup>
                    </div>
                    {
                        this.state.radioType === "1" ? <WrappedNormalLoginForm /> : <WrappedInvitationForm />
                    }
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        visible: state.CompanyModal.isShow,
    }
};
export default connect(mapStateToProps)(App)


// WEBPACK FOOTER //
// ./src/components/Content/Business/CompanyCenter/CompanyModal/index.js